export class FeedbackExecutionService {
    /*@ngInject*/
    constructor(StorageService, genericServiceAjs) {
        this.StorageService = StorageService;
        this.genericServiceAjs = genericServiceAjs;
        this.urlConstants = {
            SHOW_RECRUITER_QUESTIONS: 'api/feedbackanswers/getrecruiterscreeningquestions',
            SAVE_RECRUITER_QUESTIONS: 'api/feedbackanswers/saverecruiterscreeningquestions',
            SAVE_JOB_MATCH_STATE: 'api/feedbackanswers/savejobmatchstate',
            GET_USER_LIST: 'api/feedbackanswers/getuserlist',
            GET_CANDIDATE_DETAILS: 'api/feedbackanswers/getcandidatedetails',
            CHECK_RECRUITER_SCREENING_STATUS: 'api/feedbackanswers/checkrecruiterscreeningstatus'
        };
    }
    getCandidateDetails(jobMatchId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_CANDIDATE_DETAILS + '/' + jobMatchId).then((data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
    getUserList(jobMatchId, companyId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_USER_LIST + '/' + jobMatchId + '/' + companyId).then((data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
    getRecruiterQuestions(jobMatchId, userId, companyId, meetingScheduleId, loggedInUserId, successCallback, errorCallback) {
        let url = this.StorageService.get('baseurl') + this.urlConstants.SHOW_RECRUITER_QUESTIONS + '/' + jobMatchId + '/' + userId + '?companyId=' + companyId;
        url = !_.isNull(meetingScheduleId) ? url + '&meetingScheduleId=' + meetingScheduleId : url;
        if (!_.isNull(loggedInUserId)) {
            url = url + "&loggedInUserId=" + loggedInUserId;
        }
        this.genericServiceAjs.getObjects(url).then((data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
    saveRecruiterQuestions(feedbackExecutionResult, jobMatchId, loggedInUserId, successCallback, errorCallback) {
        let url = "api/feedbackanswers/saverecruiterscreeningquestions/" + jobMatchId;
        if (!_.isNull(loggedInUserId)) {
            url = url + "?loggedInUserId=" + loggedInUserId;
        }
        this.genericServiceAjs.addObject(url, feedbackExecutionResult).then((data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
    saveJobMatchState(listOfjobdetails, statusOfSave, questionType, successCallback, errorCallback) {
        this.genericServiceAjs.addObject("api/feedbackanswers/savejobmatchstate/" + statusOfSave, listOfjobdetails).then((data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
    checkRecruiterScreeningStatus(jobMatchId, userId, companyId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.CHECK_RECRUITER_SCREENING_STATUS + '/' + jobMatchId + '/' + userId + '?companyId=' + companyId).then((data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
}
//# sourceMappingURL=feedbackExecutionService.js.map